import { render, staticRenderFns } from "./RogueClassifieds.vue?vue&type=template&id=a3e8ce48&"
import script from "./RogueClassifieds.vue?vue&type=script&lang=ts&"
export * from "./RogueClassifieds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports